/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-18 17:39:04
 * @LastEditors: may.li
 * @LastEditTime: 2023-09-24 15:39:54
 */
import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist
let isupd = store.getters.isupd;
console.log('是否更新密码==',isupd);
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // console.log('store.getters.addRoutes====',store.getters.addRoutes)
      if (store.getters.addRoutes && store.getters.addRoutes.length > 0) {
		next()
        
      } else {
        try {
          // console.log('获取用户？？')
          const { routes } = await store.dispatch('user/getInfo')
          const accessRoutes = await store.dispatch('permission/generateRoutes', routes)
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
        //   next({ ...to, replace: true })
		next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          await store.dispatch('permission/clearRoutes')
          await store.dispatch('tagsView/delAllViews')
          Message.error(error || 'Has Error')
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {

    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      console.log(346)
      // in the free login whitelist, go directly
      next()
    } else {
      console.log(3466)
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
